/**
 * @module user.slice
 */
import { createSlice } from '@reduxjs/toolkit'

const UserSlice = createSlice({
  name: 'user',
  initialState: {
    activeUser: undefined,
    isAuthenticated: false,
  },
  reducers: {
    setActiveUser: (state, action) => {
      state.activeUser = action.payload
    },
    setIsAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload
    },
  },
})

export const { setActiveUser, setIsAuthenticated } = UserSlice.actions

export const selectActiveUser = (state) => state?.user?.activeUser
export const selectIsAuthenticated = (state) => state?.user?.isAuthenticated

export default UserSlice.reducer
